import { VIDEO_URLS } from '@/constants/videos';

const STAIImg = () => {
  return (
    <>
      {/* Mobile: Space-Time AI_2.png */}
      <section className='md:hidden relative w-full flex justify-center'>
        <img
          src='/technology/Space-Time AI_2.png'
          alt='Stai'
          className='w-full'
        />
        <video
          muted
          autoPlay
          loop
          className='absolute w-[28%] h-[30%] top-[15%] left-[32%] pointer-events-none object-cover'
          controls={false}
          disablePictureInPicture
          playsInline
          onContextMenu={e => e.preventDefault()}
        >
          <source src={VIDEO_URLS.STAI_AE} />
        </video>
      </section>

      {/* Desktop: Space-Time AI_1.png */}
      <section className='hidden md:flex relative w-full justify-center'>
        <img
          src='/technology/Space-Time AI_1.png'
          alt='Stai'
          className='w-[980px]'
        />
        <video
          muted
          autoPlay
          loop
          className='absolute xl:w-[20.8%] xl:h-[30%] xl:top-[15%] xl:left-[27.3%] md:w-[22.4%] md:h-[30%] md:top-[15%] md:left-[25.5%] pointer-events-none object-cover'
          controls={false}
          disablePictureInPicture
          playsInline
          onContextMenu={e => e.preventDefault()}
        >
          <source src={VIDEO_URLS.STAI_AE} />
        </video>
      </section>
    </>
  );
};

export default STAIImg;
